import { render, staticRenderFns } from "./DailyNotesCard.vue?vue&type=template&id=ff27e2dc&"
import script from "./DailyNotesCard.vue?vue&type=script&lang=js&"
export * from "./DailyNotesCard.vue?vue&type=script&lang=js&"
import style0 from "./DailyNotesCard.vue?vue&type=style&index=0&id=ff27e2dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports